import fields from "../global/fields";
import Buefy from "buefy";
import { library } from "@fortawesome/fontawesome-svg-core";
import sharedMixins from "../mixins/sharedMixins";
import energieausweisErstellenOnlineDeMixins from "../mixins/energieausweisErstellenOnlineDeMixins";
import { denyUrls, ignoredErrors } from "../global/errorConfig"; // Import the new config
// internal icons
import {
  faAngleLeft,
  faAngleRight,
  faArrowRight,
  faArrowUp,
  faBolt,
  faBookmark,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faCircle,
  faClock,
  faCommentAlt,
  faCopy,
  faDownload,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExternalLinkAlt, faEye,
  faFile,
  faFileAlt, faFileInvoice,
  faFilter,
  faGift,
  faHome,
  faInfo,
  faInfoCircle,
  faLightbulb,
  faMinus,
  faMousePointer,
  faPaperPlane,
  faPercent,
  faPlus,
  faQuestionCircle,
  faSave,
  faShieldAlt,
  faShoppingCart,
  faSignOutAlt,
  faStar,
  faStarHalfAlt,
  faStickyNote,
  faTag,
  faTicketAlt,
  faTrash,
  faUpload,
  faUser
} from "@fortawesome/free-solid-svg-icons";
import VueRouter from "vue-router";
import _ from "lodash";
import axios from "axios";
import { attachAxiosPostHog } from "../global/axiosPostHog";
import VueMoment from "vue-moment";
import $ from "jquery";
import VueGtag, { bootstrap } from "vue-gtag";
import "@babel/polyfill";
import VueClipboard from "vue-clipboard2";
import { extend, localize } from "vee-validate";
import de from "vee-validate/dist/locale/de.json";
import * as rules from "vee-validate/dist/rules";
import VueLazyComponent from "@xunlei/vue-lazy-component";
import FileSelector from "vue-file-selector";
import moment from "moment/moment";
import Vue from "vue";
import GmapVue from "gmap-vue";
import * as Sentry from "@sentry/vue";
import { createPinia, PiniaVuePlugin } from "pinia";
import "moment/locale/de";

import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import LaravelPermissionToVueJS from "laravel-permission-to-vuejs";
import { usePostHogStore } from "../stores/posthogStore";
import TextareaAutosize from "vue-textarea-autosize";
import { faCreditCard } from "@fortawesome/free-regular-svg-icons";

Vue.use(LaravelPermissionToVueJS);

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// Hinweis: Nur Aktivieren, sofern Vue Devtools nicht gefunden werden.
window.Vue = require("vue").default;
window.$ = window.jQuery = $;
window._ = _;

Vue.config.productionTip = false;

Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas",
  defaultFirstDayOfWeek: 1,
  defaultDateFormatter: date => date.toLocaleDateString("de-DE")
});

library.add(faUpload, faHome, faQuestionCircle, faArrowRight, faChevronDown, faExclamationCircle, faStar, faStarHalfAlt, faAngleRight, faAngleLeft, faCheck, faMinus, faPlus, faEdit,
  faTrash, faInfo, faInfoCircle, faCheckCircle, faDownload, faFile, faSave, faPaperPlane, faCopy, faShoppingCart, faMousePointer, faStickyNote, faArrowUp,
  faCircle, faPercent, faExternalLinkAlt, faFilter, faSignOutAlt, faFileAlt, faUser, faTicketAlt, faGift, faBookmark, faLightbulb, faCreditCard,
  faClock, faEnvelope, faBolt, faShieldAlt, faTag, faChartLine, faCommentAlt, faFileInvoice, faEye);

Vue.component("vue-fontawesome", () => import("@fortawesome/vue-fontawesome").then(m => m.FontAwesomeIcon));

Vue.use(VueMoment, { moment });


Vue.use(VueClipboard);
Vue.use(VueLazyComponent);
Vue.use(FileSelector);
Vue.use(TextareaAutosize);

// Global mixins
Vue.mixin({
  mixins: [sharedMixins, energieausweisErstellenOnlineDeMixins],
  methods: {
    // Add any additional methods specific to this app.js file here
  }
});

// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize("de", de);

extend("stringAndNumber", {
  message: field => {
    return "Hausnummer angeben.";
  },
  validate: value => {
    // https://regex101.com/r/cW5nP4/1
    const regex = new RegExp("(?=.*?[0-9])(?=.*?[A-Za-z]).+", "i");
    let m = regex.exec(value);
    if (m !== null)
      return true;
  }
});
extend("atMostOne1", {
  message: field => {
    return "Bitte wählen Sie nur eine Lüftungsanlage";
  },
  validate: (value, values) => {
    // Count the number of elements with value 1
    let count = values.reduce((acc, curr) => curr === 1 ? acc + 1 : acc, 0);

    if (count <= 1) {
      return { required: false, valid: true };
    }

    return { required: true, valid: false };
  }
});
extend("altLeastOne1", {
  message: field => {
    return "Bitte treffen Sie eine Auswahl.";
  },
  validate: (value, values) => {
    // Some values are truthy/present
    if (values.some(function(e) {
      return e === 1;
    })) {
      return { required: false, valid: true };
    }

    return { required: true, valid: false };
  }
});

extend("altLeastOne1Countable", {
  message: field => {
    return "Bitte treffen Sie eine Auswahl.";
  },
  validate: (value, values) => {
    // Some values are truthy/present
    if (values.some(function(e) {
      return e > 0;
    })) {
      return { required: false, valid: true };
    }

    return { required: true, valid: false };
  }
});

// window.axios = axios;
window.axios = axios;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
const token = document.head.querySelector("meta[name=\"csrf-token\"]");
//window.axios.defaults.withCredentials = true;

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token");
}

// Attach PostHog distinct_id to every Axios request as a header
attachAxiosPostHog(window.axios, { pinia });
// PostHog store will be initialized after the Vue app mounts (see below)

Vue.use(VueRouter);
const router = new VueRouter({
  mode: `history`,
  routes: []
});
window.fieldcodes = fields;

window.router = router;
window.EventBus = require("../global/Eventbus").EventBus;
window.EventBusManagement = require("../global/Eventbus").EventBusManagement;

// https://gist.github.com/reinink/a18985cee35a41f3a63585c043926981
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component("ValidationObserver", () => import("vee-validate").then(m => m.ValidationObserver));
Vue.component("ValidationProvider", () => import("vee-validate").then(m => m.ValidationProvider));

// Recovery email suppression manager (Postmark)
Vue.component("ReviewsGrid", () => import(
  /* webpackChunkName: "reviews" */ "./components/Reviews/ReviewsGrid.vue"
  ));
Vue.component("ReviewItem", () => import(
  /* webpackChunkName: "reviews" */ "./components/Reviews/ReviewItem.vue"
  ));
Vue.component("RateComponent", () => import(
  /* webpackChunkName: "reviews" */ "./components/Reviews/RateComponent.vue"
  ));
Vue.component("ReviewSummary", () => import(
  /* webpackChunkName: "reviews" */ "./components/Reviews/ReviewSummary.vue"
  ));

Vue.component("recovery-email-suppression", () => import(
  /* webpackChunkName: "admin-tools" */
  "../components/RecoveryEmailSuppression.vue"
  ));

Vue.component("form-component", () => import(
  /* webpackChunkName: "form-core" */
  /* webpackPrefetch: true */
  "../products/FormComponent.vue"
  ));
Vue.component("modal-legal", () => import(
  /* webpackChunkName: "modals" */
  "../products/Energieausweis/formular/checkout-partials/legalModal.vue"
  ));
Vue.component("page1-picture-management", () => import(
  /* webpackChunkName: "modals" */
  "../products/Energieausweis/pdf_partials/partials/page1PictureManagementModal.vue"
  ));
Vue.component("navigationMobileComponent", () => import(
  /* webpackChunkName: "navigation" */
  "../products/Energieausweis/formular/partials/navigationMobileComponent"
  ));
Vue.component("rightHelptextColumn", () => import(
  /* webpackChunkName: "form-helpers" */
  "../products/Energieausweis/formular/partials/rightHelptextColumn"
  ));
Vue.component("helpFormLabel", () => import(
  /* webpackChunkName: "form-helpers" */
  "../products/Energieausweis/formular/partials/helpFormLabel.vue"
  ));
Vue.component("Step1VA", () => import(
  /* webpackChunkName: "form-va-steps" */
  /* webpackPrefetch: true */
  "../products/Energieausweis/formular/VA/Step1VA"
  ));
Vue.component("Step2VA", () => import(
  /* webpackChunkName: "form-va-steps" */
  "../products/Energieausweis/formular/VA/Step2VA"
  ));
Vue.component("Step3VA", () => import(
  /* webpackChunkName: "form-va-steps" */
  "../products/Energieausweis/formular/VA/Step3VA"
  ));
Vue.component("Step4VA", () => import(
  /* webpackChunkName: "form-va-steps" */
  "../products/Energieausweis/formular/VA/Step4VA"
  ));
Vue.component("Step1BA", () => import(
  /* webpackChunkName: "form-ba-steps" */
  /* webpackPrefetch: true */
  "../products/Energieausweis/formular/BA/Step1BA"
  ));
Vue.component("Step2BA", () => import(
  /* webpackChunkName: "form-ba-steps" */
  "../products/Energieausweis/formular/BA/Step2BA"
  ));
Vue.component("Step3BA", () => import(
  /* webpackChunkName: "form-ba-steps" */
  "../products/Energieausweis/formular/BA/Step3BA"
  ));
Vue.component("Step4BA", () => import(
  /* webpackChunkName: "form-ba-steps" */
  "../products/Energieausweis/formular/BA/Step4BA"
  ));
Vue.component("Step5BA", () => import(
  /* webpackChunkName: "form-ba-steps" */
  "../products/Energieausweis/formular/BA/Step5BA"
  ));
Vue.component("quiz_product_chooser", () => import(
  /* webpackChunkName: "quiz" */
  /* webpackPrefetch: true */
  "../products/Energieausweis/partials/quiz_product_chooser"
  ));
Vue.component("DataOverview", () => import(
  /* webpackChunkName: "checkout-flow" */
  /* webpackPrefetch: true */
  "../products/Energieausweis/formular/DataOverview"
  ));
Vue.component("Checkout", () => import(
  /* webpackChunkName: "checkout-flow" */
  /* webpackPrefetch: true */
  "../products/Energieausweis/formular/Checkout"
  ));
Vue.component("OrderConfirmationPage", () => import(
  /* webpackChunkName: "checkout-flow" */
  "../products/Energieausweis/formular/OrderConfirmationPage"
  ));
Vue.component("HelpModal", () => import(
  /* webpackChunkName: "modals" */
  "../products/Energieausweis/formular/partials/helpModal.vue"
  ));
Vue.component("CustomerNoticeAndAdditionalDocs", () => import(
  /* webpackChunkName: "form-helpers" */
  "../products/Energieausweis/formular/partials/customerNoticeAndAdditionalDocs.vue"
  ));
Vue.component("CustomerNoticeAndAdditionalDocsModal", () => import(
  /* webpackChunkName: "modals" */
  "../products/Energieausweis/formular/partials/customerNoticeAndAdditionalDocsModal.vue"
  ));
Vue.component("Steps", () => import(
  /* webpackChunkName: "navigation" */
  "../products/Energieausweis/formular/Steps"
  ));
// Checkout payment components (client-only)
Vue.component("mollie_googlepay", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_googlepay.vue"
  ));
Vue.component("mollie_trustly", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_trustly.vue"
  ));
Vue.component("mollie_applepay", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_applepay.vue"
  ));
Vue.component("mollie_giropay", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_giropay.vue"
  ));
Vue.component("mollie_paypal", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_paypal.vue"
  ));
Vue.component("mollie_sofort", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_sofort.vue"
  ));
Vue.component("mollie_banktransfer", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_banktransfer.vue"
  ));
Vue.component("mollie_creditcard", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_creditcard.vue"
  ));
Vue.component("mollie_directdebit", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_directdebit.vue"
  ));
Vue.component("mollie_klarna", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/mollie_klarna.vue"
  ));
Vue.component("no_payment_required", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/checkout-partials/no_payment_required.vue"
  ));
// Checkout: additional globally registered components used in client checkout
Vue.component("payment_selection", () => import(
  /* webpackChunkName: "checkout-flow" */
  "../products/Energieausweis/formular/checkout-partials/payment_selection.vue"
  ));
Vue.component("legal_checkboxes_and_submit", () => import(
  /* webpackChunkName: "checkout-flow" */
  "../products/Energieausweis/formular/checkout-partials/legal_checkboxes_and_submit.vue"
  ));
Vue.component("checkout-error-message", () => import(
  /* webpackChunkName: "checkout-flow" */
  "../products/Energieausweis/formular/partials/checkout/CheckoutErrorMessages.vue"
  ));
Vue.component("trusted-shop-badge", () => import(
  /* webpackChunkName: "checkout-flow" */
  "../global/partials/trustedShopBadge.vue"
  ));
Vue.component("FormCustomerAdress", () => import(
  /* webpackChunkName: "form-customer-data" */
  "../products/Energieausweis/formular/form-partials/FormCustomerAdress.vue"
  ));
Vue.component("ShoppingCard", () => import(
  /* webpackChunkName: "checkout-flow" */
  "../products/Energieausweis/formular/partials/checkout/ShoppingCard.vue"
  ));
Vue.component("CouponInput", () => import(
  /* webpackChunkName: "checkout-flow" */
  "../products/Energieausweis/formular/partials/checkout/CouponInput.vue"
  ));

Vue.component("ActiveUserCoupons", () => import(
  /* webpackChunkName: "checkout-flow" */
  "../products/Energieausweis/formular/partials/checkout/ActiveUserCoupons.vue"
  ));
Vue.component("Paypal_partial", () => import(
  /* webpackChunkName: "payment-methods" */
  "../products/Energieausweis/formular/partials/paypal_partial.vue"
  ));
Vue.component("OrderOptions", () => import(
  /* webpackChunkName: "checkout-flow" */
  "../products/Energieausweis/formular/partials/checkout/OrderOptions.vue"
  ));
Vue.component("FormContactData", () => import(
  /* webpackChunkName: "form-customer-data" */
  "../products/Energieausweis/formular/form-partials/FormContactData.vue"
  ));
Vue.component("EnergieausweisHeader", () => import(
  /* webpackChunkName: "pdf-partials" */
  "../products/Energieausweis/pdf_partials/partials/EnergieausweisHeader.vue"
  ));
Vue.component("EnergieausweisBox", () => import(
  /* webpackChunkName: "pdf-partials" */
  "../products/Energieausweis/pdf_partials/partials/EnergieausweisBox.vue"
  ));
Vue.component("Energy_scale", () => import(
  /* webpackChunkName: "pdf-partials" */
  "../products/Energieausweis/pdf_partials/partials/energy_scale.vue"
  ));
Vue.component("EnergieausweisSubTitle", () => import(
  /* webpackChunkName: "pdf-partials" */
  "../products/Energieausweis/pdf_partials/partials/EnergieausweisSubTitle.vue"
  ));

// Formular
Vue.component("FormInformationCarousel", () => import(
  /* webpackChunkName: "form-helpers" */
  "../products/Energieausweis/formular/partials/FormInformationCarousel.vue"
  ));
Vue.component("rightHelptextColumn", () => import(
  /* webpackChunkName: "form-helpers" */
  "../products/Energieausweis/formular/partials/rightHelptextColumn"
  ));
Vue.component("EnergieausweisView", () => import(
  /* webpackChunkName: "pdf-viewer" */
  "../products/Energieausweis/view_helper/EnergieausweisView.vue"
  ));
// VA Form Partials
Vue.component("FormStep1VA", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormStep1VA"
  ));
Vue.component("FormPropertyInformations", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormPropertyInformations"
  ));
Vue.component("FormAircondition", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormAircondition"
  ));
Vue.component("FormVacant", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormVacant"
  ));
Vue.component("FormVaBasement", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormVaBasement"
  ));
Vue.component("FormVaOptionalQuestions", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormVaOptionalQuestions"
  ));
Vue.component("FormFileuploadPropertyVA", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormFileuploadPropertyVA"
  ));
Vue.component("FormEnergyUsage1", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormEnergyUsage1"
  ));
Vue.component("FormEnergyUsage2", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormEnergyUsage2"
  ));
Vue.component("FormWaterHeating", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormWaterHeating"
  ));
Vue.component("FormWaterHeating2", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormWaterHeating2"
  ));
Vue.component("FormEnergyConsumption", () => import(
  /* webpackChunkName: "form-va-partials" */
  "../products/Energieausweis/formular/VA/partials/FormEnergyConsumption"
  ));

// BA Form Partials
Vue.component("FormPropertyDimensions", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormPropertyDimensions"
  ));
Vue.component("FormFileupload", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormFileuploadProperty"
  ));
Vue.component("FormFileuploadBA", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormFileuploadBA"
  ));

// Shared Form Partials
Vue.component("FormRenewableEnergyUsage", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../products/Energieausweis/formular/form-partials/FormRenewableEnergyUsage"
  ));
Vue.component("FormRenewableEnergyUsageV02", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../products/Energieausweis/formular/form-partials/FormRenewableEnergyUsageV02"
  ));
Vue.component("FormObjectAddress", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../products/Energieausweis/formular/form-partials/FormObjectAddress"
  ));
Vue.component("FormObjectJamb", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../products/Energieausweis/formular/form-partials/FormObjectJamb"
  ));
Vue.component("FileUpload", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../products/Energieausweis/formular/partials/fileUpload"
  ));
// BA Form Partials - continued
Vue.component("FormMeasurement", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormMeasurement"
  ));
Vue.component("FormBasement", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormBasement"
  ));
Vue.component("PropertyOrientationPartial", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/PropertyOrientationPartial"
  ));
Vue.component("FormRoofSecondFloor", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormRoofSecondFloor"
  ));
Vue.component("FormPropertyMounted", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormPropertyMounted"
  ));
Vue.component("FormWindows", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormWindows"
  ));
Vue.component("FormWindows2", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormWindows2"
  ));
Vue.component("FormRoof", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormRoof"
  ));
Vue.component("FormRoofDormers", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormRoofDormers"
  ));
Vue.component("FormRoofAdditionalInformations", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormRoofAdditionalInformations"
  ));
Vue.component("FormHeating2AdditionalInformations", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormHeating2AdditionalInformations"
  ));
Vue.component("FormObjectInformations", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormObjectInformations"
  ));
Vue.component("FormStep1BA", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormStep1BA"
  ));
Vue.component("FormRoofWindows", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormRoofWindows"
  ));
Vue.component("FormHeatingInformation", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormHeatingInformation"
  ));
Vue.component("FormHeatingInformation_v02", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormHeatingInformation_v02.vue"
  ));
Vue.component("FormHeating2Information", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormHeating2Information"
  ));
Vue.component("FormWater2", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormWater2"
  ));
Vue.component("FormHeatingAdditionalInformations", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormHeatingAdditionalInformations"
  ));
Vue.component("FormWWAdditionalInformations", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormWWAdditionalInformations"
  ));
Vue.component("FormWW2AdditionalInformations", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormWW2AdditionalInformations"
  ));
Vue.component("FormBaOptionalQuestions", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/BA/partials/FormBaOptionalQuestions"
  ));

// Shared Form Components
Vue.component("google-maps-partial", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../app_immobilienwerker_de/partials/googleMapsPartial"
  ));
Vue.component("FormObjectAnnexes", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../products/Energieausweis/formular/form-partials/FormObjectAnnexes"
  ));
Vue.component("uValues", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../products/Energieausweis/formular/form-partials/uValues"
  ));
Vue.component("FormVentilationCheckbox", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../products/Energieausweis/formular/form-partials/FormVentilationCheckbox"
  ));
Vue.component("EMailInput", () => import(
  /* webpackChunkName: "form-shared-partials" */
  "../products/Energieausweis/formular/form-partials/EMailInput"
  ));
Vue.component("StepsBar", () => import(
  /* webpackChunkName: "navigation" */
  "../products/Energieausweis/formular/partials/stepsBar"
  ));
Vue.component("QrCodeModal", () => import(
  /* webpackChunkName: "modals" */
  "../products/Energieausweis/formular/form-partials/QrCodeModal"
  ));
Vue.component("CompleteFormLaterModal", () => import(
  /* webpackChunkName: "modals" */
  "../products/Energieausweis/formular/partials/completeFormLaterModal.vue"
  ));
// Auth Components
Vue.component("AuthDashboard", () => import(
  /* webpackChunkName: "auth" */
  "../products/auth/v01/AuthDashboard.vue"
  ));
Vue.component("AuthDashboardV02", () => import(
  /* webpackChunkName: "auth" */
  "../products/auth/v02/AuthDashboard.vue"
  ));
Vue.component("AuthEnergieausweisEdit", () => import(
  /* webpackChunkName: "auth" */
  "../products/auth/v01/orders/EditEnergieausweis.vue"
  ));
Vue.component("AuthEnergieausweisEditV02", () => import(
  /* webpackChunkName: "auth" */
  "../products/auth/v02/orders/EditEnergieausweis.vue"
  ));
Vue.component("AuthFaqIndex", () => import(
  /* webpackChunkName: "auth" */
  "../products/auth/v01/faq/index.vue"
  ));
Vue.component("AuthFaqIndexV02", () => import(
  /* webpackChunkName: "auth" */
  "../products/auth/v02/faq/index.vue"
  ));

Vue.component("PaymentButtonV02", () => import(
  /* webpackChunkName: "auth" */
  "../products/auth/v02/orders/partials/payment_button.vue"
  ));

Vue.component("coupon-manager", () =>
  import(
    /* webpackChunkName: "auth" */
    "./../app_immobilienwerker_de/coupons/CouponManager.vue"
    )
);
// Global Helpers
Vue.component("NotionPage", () => import(
  /* webpackChunkName: "global-helpers" */
  "../global/partials/NotionPage.vue"
  ));
Vue.component("ContactInformations", () => import(
  /* webpackChunkName: "global-helpers" */
  "../global/partials/ContactInformations.vue"
  ));
Vue.component("box-toggleable", () => import(
  /* webpackChunkName: "global-helpers" */
  "../app_immobilienwerker_de/partials/boxToggleable.vue"
  ));
Vue.component("stepper", () => import(
  /* webpackChunkName: "form-helpers" */
  "../products/Energieausweis/formular/partials/stepper.vue"
  ));
Vue.component("ba_property_part", () => import(
  /* webpackChunkName: "form-ba-partials" */
  "../products/Energieausweis/formular/partials/singleFieldsComponents/ba_property_part.vue"
  ));

// PDF Pages
Vue.component("Page1", () => import(
  /* webpackChunkName: "pdf-viewer" */
  "../products/Energieausweis/pdf_partials/Page1.vue"
  ));
Vue.component("Page2", () => import(
  /* webpackChunkName: "pdf-viewer" */
  "../products/Energieausweis/pdf_partials/Page2.vue"
  ));
Vue.component("Page3", () => import(
  /* webpackChunkName: "pdf-viewer" */
  "../products/Energieausweis/pdf_partials/Page3.vue"
  ));
Vue.component("Page4", () => import(
  /* webpackChunkName: "pdf-viewer" */
  "../products/Energieausweis/pdf_partials/Page4.vue"
  ));
Vue.component("Page5", () => import(
  /* webpackChunkName: "pdf-viewer" */
  "../products/Energieausweis/pdf_partials/Page5.vue"
  ));

// Chooser & Helpers
Vue.component("find_correct_ea", () => import(
  /* webpackChunkName: "quiz" */
  "../products/Energieausweis/partials/find_correct_ea.vue"
  ));
Vue.component("energieausweis_chooser", () => import(
  /* webpackChunkName: "quiz" */
  "../products/Energieausweis/partials/Energieausweis_chooser.vue"
  ));
Vue.component("review-carousel", () => import(
  /* webpackChunkName: "global-helpers" */
  "./components/ReviewCarousel.vue"
  ));
Vue.component("customer-logo-gallery", () => import(
  /* webpackChunkName: "global-helpers" */
  "./components/CustomerLogoGallery.vue"
  ));

// Cal/Booking Components
Vue.component("cal-booking", () => import(
  /* webpackChunkName: "cal-booking" */
  "../components/cal/cal-booking.vue"
  ));
Vue.component("cal-bookings", () => import(
  /* webpackChunkName: "cal-booking" */
  "../components/cal/cal-bookings.vue"
  ));
Vue.component("cal-admin", () => import(
  /* webpackChunkName: "cal-booking" */
  "../components/cal/cal-admin.vue"
  ));
Vue.component("cal-upcoming-bookings", () => import(
  /* webpackChunkName: "cal-booking" */
  "../components/cal/cal-upcoming-bookings.vue"
  ));
Vue.component("me-benefits-dashboard", () => import("./benefits/MeBenefitsDashboard.vue"));


// Filter
Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY");
  }
});

Vue.use(GmapVue, {
  load: {
    // [REQUIRED] This is the unique required value by Google Maps API
    key: process.env.MIX_GOOGLE_PLACES_API_KEY,
    // [OPTIONAL] This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    libraries: "places,geometry,Geocoder",

    // [OPTIONAL] If you want to set the version, you can do so:
    v: "3.26",

    // This option was added on v3.0.0 but will be removed in the next major release.
    // If you already have an script tag that loads Google Maps API and you want to use it set you callback
    // here and our callback `GoogleMapsCallback` will execute your custom callback at the end; it must attached
    // to the `window` object, is the only requirement.
    customCallback: "MyCustomCallback"
  },

  // [OPTIONAL] If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  autoBindAllEvents: false,

  // [OPTIONAL] If you want to manually install components, e.g.
  // import {GmapMarker} from 'gmap-vue/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then set installComponents to 'false'.
  // If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,

  // Load the Google Maps API dynamically, if you set this to `true` the plugin doesn't load the Google Maps API
  dynamicLoad: true
});

if (process.env.MIX_APP_ENV === "production") {

  Sentry.init({
    Vue,
    dsn: "https://972668f463e9f5bd73728b605471c44d@o4507264403046400.ingest.de.sentry.io/4507264405143632",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(
        {
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false,
          minReplayDuration: 15000
        }
      )
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets:
      [],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    denyUrls: denyUrls,
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error?.message && ignoredErrors.some(ignored => error.message.includes(ignored))) {
        return; // Suppress the event
      }
      return event;
    }
  });
}

// AdWords aktiviert auf dieser Seite?
if (process.env.MIX_GOOGLE_ADWORDS_ACCOUNT) {
  Vue.use(VueGtag,
    {
      config: {
        id: process.env.MIX_GOOGLE_ADWORDS_ACCOUNT,
        params: {
          anonymize_ip: true
        }
      },

      // enabled: false ( mit this.$gtag.config({enabled: true}) aktivieren)
      // disableScriptLoad: false,
      bootstrap: false,
      appName: "APP-" + process.env.MIX_GOOGLE_ADWORDS_ACCOUNT,
      pageTrackerScreenviewEnabled: false
      // pageTrackerEnabled: true,
      // pageTrackerScreenviewEnabled: true,
    }, router);
}

const app = new Vue({
  el: "#app",
  router,
  pinia
});

// Initialize the PostHog store only after the Vue app (with Pinia) is mounted
Vue.nextTick(() => {
  try {
    const phStore = usePostHogStore(pinia);
    phStore.init();
    if (typeof window !== "undefined") {
      window.$ph = phStore;
    }
  } catch (e) { /* no-op */
  }
});

// AdWords aktiviert auf dieser Seite?
if (process.env.MIX_GOOGLE_ADWORDS_ACCOUNT) {
  // CookieScript loaded?
  window.addEventListener("CookieScriptLoaded", function() {
    // Default MS content mode
    try {
      window.uetq = window.uetq || [];
      window.uetq.push("consent", "default", {
        "ad_storage": "denied"
      });
    } catch (e) {
      console.error("Allgemeiner Fehler:", e);
    }

    const consentState = CookieScript.instance.currentState();
    app.cookieRejectMicrosoft();

    if (consentState.action === "accept") {
      bootstrap().then((gtag) => {
        if (!app.isProduction()) console.log("[DEV] 🍪 gtag geladen, da cookies bereits akzeptiert wurden");
        app.cookieAccept();
      });
    }
    if (consentState.action === "reject") {
      bootstrap().then((gtag) => {
        if (!app.isProduction()) console.log("[DEV] 🍪❌ gtag nicht geladen, da cookies nicht akzeptiert wurden");
      });
    }

    // Fires when CookieScript.Instance is ready and its functions are available to use.
    if (!app.isProduction()) console.log("[DEV] 🍪 loaded CookieScriptLoaded event");
    if (consentState.action !== "accept") {
      app.cookieRejectMicrosoft()
        .then(() => {
          if (!app.isProduction()) console.log("[DEV] 🍪 MS Consent deaktiviert");
        });
    }
    window.addEventListener("CookieScriptAcceptAll", function(e) {
      app.cookieAccept()  // Zugriff auf die Methode innerhalb der Vue-Instanz
        .then(() => {
          if (!app.isProduction()) console.log("[DEV] 🍪 Consent aktiviert");
        });
    });
    window.addEventListener("CookieScriptAccept", function(e) {
      app.cookieAccept()  // Zugriff auf die Methode innerhalb der Vue-Instanz
        .then(() => {
          if (!app.isProduction()) console.log("[DEV] 🍪 Consent aktiviert");
        });
    });

    // Cookies Reject
    window.addEventListener("CookieScriptReject", function() {
      app.cookieReject();
      if (!app.isProduction()) console.log("[DEV] 🍪❌ Consent rejected");
    });
  });
}
